// get all
export const FLAG_GETTING_TICKET_REASSIGNMENTS =
  'FLAG_GETTING_TICKET_REASSIGNMENTS';
export const GET_TICKET_REASSIGNMENTS = 'GET_TICKET_REASSIGNMENTS';
export const CLEAR_TICKET_REASSIGNMENTS = 'CLEAR_TICKET_REASSIGNMENTS';

// get one
export const FLAG_TICKET_REASSIGNMENT_ACTIVITY =
  'FLAG_TICKET_REASSIGNMENT_ACTIVITY';
export const GET_TICKET_REASSIGNMENT = 'GET_TICKET_REASSIGNMENT';
export const CLEAR_TICKET_REASSIGNMENT = 'CLEAR_TICKET_REASSIGNMENT';
